import React from 'react';
import { Skeleton } from 'antd';

interface TabListLoadingProps {
  loading: boolean;
  children: React.ReactNode;
  minHeight?: number;
  /** Tablo benzeri satır sayısı (varsayılan 6) */
  rows?: number;
}

/** Liste/tablo tab'larında veri gelirken iskelet loading */
const TabListLoading: React.FC<TabListLoadingProps> = ({
  loading,
  children,
  minHeight = 320,
  rows = 6,
}) => {
  if (loading) {
    return (
      <div style={{ minHeight, width: '100%', padding: '16px 0' }}>
        {/* Başlık / filtre alanı iskeleti */}
        <div style={{ marginBottom: 16, display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <Skeleton.Input active size="small" style={{ width: 280, height: 40 }} />
          <Skeleton.Button active size="small" style={{ width: 100, height: 40 }} />
        </div>
        {/* Tablo başlık satırı */}
        <div style={{ marginBottom: 12, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <Skeleton active paragraph={false} title={{ width: '16%' }} />
          <Skeleton active paragraph={false} title={{ width: '20%' }} />
          <Skeleton active paragraph={false} title={{ width: '18%' }} />
          <Skeleton active paragraph={false} title={{ width: '12%' }} />
          <Skeleton active paragraph={false} title={{ width: '14%' }} />
        </div>
        {/* Tablo satırları */}
        {Array.from({ length: rows }).map((_, i) => (
          <div
            key={i}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              marginBottom: 12,
              padding: '8px 0',
              borderBottom: i < rows - 1 ? '1px solid var(--border-light, #f0f0f0)' : 'none',
            }}
          >
            <Skeleton.Avatar active size={32} shape="square" />
            <Skeleton active paragraph={false} title={{ width: `${70 + (i % 3) * 5}%` }} style={{ flex: 1 }} />
            <Skeleton active paragraph={false} title={{ width: 60 }} />
            <Skeleton active paragraph={false} title={{ width: 50 }} />
          </div>
        ))}
      </div>
    );
  }
  return <>{children}</>;
};

export default TabListLoading;
